import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import type { IPresetButton } from './types';

export const PresetButton = (props: IPresetButton): JSX.Element => {
  const { isSelected, disabled = false, children, handleClick, isMobile } = props;
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!isMobile || !isSelected) return;

    buttonRef.current?.scrollIntoView({ behavior: 'smooth', inline: 'end' });
  }, []);

  return (
    <ButtonWrapper
      type="button"
      disabled={disabled}
      $isSelected={isSelected}
      onClick={handleClick}
      ref={buttonRef}
    >
      {children}
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.button<{ $isSelected: boolean; disabled: boolean }>`
  cursor: pointer;
  font: inherit;
  line-height: inherit;
  white-space: nowrap;

  max-height: 52px;

  margin: 4px;
  padding: 8px;

  border: 1px solid ${({ $isSelected }) => ($isSelected ? '#f8e71c' : '#C2C5CC')};
  border-radius: 4px;

  background: ${({ $isSelected }) => ($isSelected ? '#FFFBE5' : 'none')};
  color: ${({ $isSelected }) => ($isSelected ? '#17181A' : '#4D4D4D')};

  & svg path,
  svg rect {
    stroke: ${({ $isSelected }) => ($isSelected ? '#17181A' : '#919499')};
  }

  ${({ disabled }) =>
    disabled
      ? `
    color: #c2c5cc;
    cursor: initial;
  `
      : `
    &:hover {
      background: #fffbe5;
      border-color: #f8e71c;
      color: #17181a;

      & svg path,
      svg rect {
        stroke: #17181a;
      }
    }
  `}
`;
